var React = require('react');

function No (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#ed2939","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M180 0h120v480H180z","key":1}),React.createElement("path",{"fill":"#fff","d":"M0 180h640v120H0z","key":2}),React.createElement("path",{"fill":"#002664","d":"M210 0h60v480h-60z","key":3}),React.createElement("path",{"fill":"#002664","d":"M0 210h640v60H0z","key":4})]);
}

No.defaultProps = {"id":"flag-icons-no","viewBox":"0 0 640 480"};

module.exports = No;

No.default = No;
